const LangDefaultCardForm = {
	"defaultCardForm.form._title": ["MY TRANSACTIONS", "Giao dịch của tôi"],
	"defaultCardForm.copy._storeValue": ["STORED VALUE", "Số tiền trên thẻ"],
	"defaultCardForm.copy._expiryDate": ["EXPIRY DATE", "Ngày hết hạn"],
	"defaultCardForm.form.label._isDefault": ["Set as Default", "Chọn làm thẻ mặc định"],
}

export default LangDefaultCardForm



// WEBPACK FOOTER //
// ./src/resources/modules/LangDefaultCardForm.js